/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { getGetRequestOptions } from "../components/GetToken";
import { AppContext } from '../context/AppContext';
import { Button, Modal } from "react-bootstrap";
import EquipmentFuelLogs from '../components/EquipmentFuelLogs';
import LogBookFuelCreate from '../components/LogBookFuelCreate';

const FuelLogDayWiseEntry = () => {
    const { jwt } = useContext(AppContext);
    const [project, setProject] = useState("");
    const [logDate, setLogDate] = useState("");
    const [allBusinessUnits, setAllBusinessUnits] = useState([]);
    const [logBookData, setLogBookData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedEquipment, setSelectedEquipment] = useState(null);
    const [logListModalShow, setLogListModalShow] = useState(false);
    const [fuelLogCreateModalShow, setFuelLogCreateModalShow] = useState(false);

    useEffect(() => {
        getAllBu();
    }, []);

    useEffect(() => {
        if (project?.value && logDate) {
            getLogBookData();
        }
    }, [project, logDate]);

    const getAllBu = () => {
        fetch(process.env.REACT_APP_API_URL + "get_business_units", getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const tempResp = resp.data
                    .map(element => ({
                        ...element,
                        label: element.projectName,
                        value: element.projectId,
                        isdisabled: element.projectName === 'EMD' ? false : true
                    }))
                    .filter(e => e.projectId !== process.env.REACT_APP_EMD_BU_ID);
                setAllBusinessUnits(tempResp);
            })
            .catch((error) => {
                console.log(error, "catch the hoop");
            });
    };

    const handleInputOnChange = (evt) => {
        const { name, value } = evt.target;
        if (name === 'logDate') {
            setLogDate(value);
        }
    };

    const getLogBookData = () => {
        if (!project?.value || !logDate) {
            return;
        }

        setLoading(true);
        setLogBookData([]);

        fetch(`${process.env.REACT_APP_API_URL}log_book/project_day_wise_equipment_fuel_logs/${project.value}/${logDate}`, {
            ...getGetRequestOptions(),
            headers: {
                ...getGetRequestOptions().headers,
                'Authorization': 'Bearer ' + jwt.token
            }
        })
            .then((resp) => {
                if (!resp.ok) {
                    throw new Error(`HTTP error! status: ${resp.status}`);
                }
                return resp.json();
            })
            .then((resp) => {
                setLoading(false);
                if (resp.success) {
                    setLogBookData(resp.data || []);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: resp.heading || 'Error',
                        text: resp.errorMessage || 'Failed to fetch data'
                    });
                    setLogBookData([]);
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching log book data:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch log book data. Please try again.'
                });
                setLogBookData([]);
            });
    };

    const getSummaryData = () => {
        if (!filteredLogBookData || filteredLogBookData.length === 0) return null;

        return {
            totalFuelQuantity: filteredLogBookData.reduce((sum, equipment) => sum + parseInt(equipment.totalFuelQty || 0), 0),
        };
    };

    const filteredLogBookData = logBookData.filter(equipment =>
        equipment.equipmentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        equipment.equipmentCode.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const summaryData = getSummaryData();

    const tableBody = () => {
        if (!filteredLogBookData || filteredLogBookData.length === 0) {
            return (
                <tr>
                    <td colSpan="9" className="text-center">No data available</td>
                </tr>
            );
        }

        return filteredLogBookData.map((equipment, index) => (
            <tr key={equipment.equipmentId}>
                <td>{index + 1}</td>
                <td>{equipment.equipmentName}</td>
                <td>{equipment.equipmentCode}</td>
                <td>{equipment.model}</td>
                <td className="text-info font-weight-bold">{equipment.fuelType}</td>
                <td className="text-danger font-weight-bold">{equipment.tankCapacity}</td>
                <td className="text-warning font-weight-bold">{equipment.refuelingDate}</td>
                <td className="text-success font-weight-bold">{equipment.totalFuelQty}</td>
                <td>
                    <div className="btn-group" role="group">
                        <Button
                            variant="info"
                            size="sm"
                            onClick={() => showLogList(equipment)}
                            title="View Logs"
                        >
                            <i className="fa fa-list"></i>
                        </Button>

                        <Button
                            variant="success"
                            size="sm"
                            onClick={() => createFuelLog(project, logDate, equipment)}
                            className="ml-1"
                            title="Add Entry"
                        >
                            <i className="fa fa-plus"></i>
                        </Button>
                    </div>
                </td>
            </tr>
        ));
    };

    const showLogList = (equipment) => {
        setSelectedEquipment(equipment);
        setLogListModalShow(true);
    };

    const createFuelLog = (project, logDate, equipment) => {
        if (!project || !logDate || !equipment) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please select a project, date, and equipment before adding a fuel log.'
            });
            return;
        }
        setSelectedEquipment({
            equipmentId: equipment.equipmentId,
            equipmentName: equipment.equipmentName,
            label: `${equipment.equipmentName} (${equipment.equipmentCode})`,
            value: equipment.equipmentId,
            equipmentCode: equipment.equipmentCode
        });
        setFuelLogCreateModalShow(true);
        setLogListModalShow(false);
    };

    const onChange = () => {
        getLogBookData();
    }

    return (
        <div className="card card-custom">
            <div className="card-header">
                <h3 className="card-title">Fuel Log Day Wise Entry</h3>
            </div>
            <div className="card-body">
                <form>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Project</label>
                                <Select
                                    value={project}
                                    onChange={setProject}
                                    options={allBusinessUnits}
                                    isClearable
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="logDate"
                                    value={logDate}
                                    onChange={handleInputOnChange}
                                />
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Search Equipment</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by equipment name or code..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    {!loading && logBookData.length > 0 && (
                        <div className="row mb-3">
                            <div className="col-md-12">
                                <small className="text-muted">
                                    Showing {filteredLogBookData.length} of {logBookData.length} equipment
                                </small>
                            </div>
                        </div>
                    )}

                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th>SL</th>
                                            <th>Equipment Name</th>
                                            <th>Code</th>
                                            <th>Model</th>
                                            <th className='text-info'>Fuel Type</th>
                                            <th className='text-danger'>Tank Capacity</th>
                                            <th className='text-warning'>Refueling Date</th>
                                            <th className='text-success'>Fuel Qty</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableBody()}
                                    </tbody>
                                </table>
                            </div>

                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">Summary</h6>
                                            {summaryData && (
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="text-center">
                                                            <div className="text-success h4">{filteredLogBookData.length}</div>
                                                            <strong>Total Equipment</strong>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="text-center">
                                                            <div className="text-warning h4">{summaryData.totalFuelQuantity}</div>
                                                            <strong>Total Refueling (L)</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </form>
            </div>
            <Modal
                show={logListModalShow}
                onHide={() => setLogListModalShow(false)}
                size="xl"
                style={{ zIndex: 1050 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Equipment Fuel Logs - {selectedEquipment?.equipmentName} ({selectedEquipment?.equipmentCode})
                        <br />
                        <small className="text-muted">Date: {logDate}</small>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EquipmentFuelLogs equipment={selectedEquipment} logDate={logDate} onChange={onChange} />
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setLogListModalShow(false)}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={fuelLogCreateModalShow}
                onHide={() => setFuelLogCreateModalShow(false)}
                size="lg"
                style={{ zIndex: 1060 }}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Create Fuel Log Entry - {selectedEquipment?.equipmentName} ({selectedEquipment?.equipmentCode})
                        <br />
                        <small className="text-muted">
                            {project?.label} - {logDate}
                        </small>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <LogBookFuelCreate
                        project={project}
                        logDate={logDate}
                        equipment={selectedEquipment}
                        onClose={() => {
                            setFuelLogCreateModalShow(false);
                            setLogListModalShow(false);
                        }}
                        onLogCreated={() => {
                            setFuelLogCreateModalShow(false);
                            setLogListModalShow(false);
                            getLogBookData();
                        }}
                    />
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default FuelLogDayWiseEntry;